import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { breakpoints } from '@/css/resources/variables.css';
import {
	gridContentDefault,
	grid,
	gridFull,
	resetFirstLastMargins,
} from '@/css/resources/placeholders.css';
import { fontStyle, fluidPadding } from '@/css/resources/mixins.css';

const getDynamicStyles = (styles) =>
	cssObj(fluidPadding(styles?.padding), {
		background: styles?.backgroundColor,

		'.supt-pageHeaderSimple__inner': {
			'.supt-pageHeaderSimple__title': fontStyle({
				...styles?.title?.typography,
				textAlign: styles?.title?.textAlignment,
				color: styles?.title?.color,
			}),
		},
	});

const getStyles = (styles) =>
	css(getDynamicStyles(styles), {
		position: 'relative',

		'.supt-pageHeaderSimple__inner': cssObj(grid, {
			position: 'relative',
			zIndex: 2,

			'& > *': cssObj(gridFull, {
				[`@media (min-width: ${breakpoints.tablet})`]: {
					gridColumn: '1/12',
				},
			}),

			'.supt-pageHeaderSimple__title': resetFirstLastMargins,
		}),

		'.supt-pageHeaderSimple__imageWrapper': {
			position: 'absolute',
			top: 0,
			right: 0,
			bottom: 0,
			left: 0,
			width: '100%',
			height: '100%',
			zIndex: 1,
			overflow: 'hidden',
			pointerEvents: 'none',

			/* img: {
				objectFit: 'cover',
			} */
		},

		'&.supt-pageHeaderSimple--isPost': {
			'.supt-pageHeaderSimple__inner .supt-pageHeaderSimple__title':
				gridContentDefault,
		},
	});

const getEditStyles = () =>
	css({
		maxWidth: 'none !important',

		'.supt-pageHeaderSimple__imageWrapper': {
			img: {
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
				zIndex: 1,
				objectFit: 'cover',
			},
		},
	});

export { getStyles, getEditStyles };
